import { ECountry } from '@core/type';

import { COUNTRY, IPlace } from './interface';

export const isPlaceOutsideCountryList = (place: IPlace, countryList: ECountry[]) => {
  for (const component of place.address_components) {
    const componentType = component.types[0];

    if (componentType === COUNTRY && !countryList.includes(component.short_name as ECountry)) {
      return true;
    }
  }
  return false;
};
